import { reactive } from 'vue'
import { loginCommonConfig } from './common'
import type { LoginPageConfig } from './types'

export const theme = {
  facebookBlue: '#1A77F2',
  googleBlue: '#239FFB',
  appleDark: '#282828',
  inputBorder: 'rgba(216, 115, 147, 0.18)',
} as const

export const resources = {
  loginBg: '/images/storlyn/login/login-bg.webp',
  logo: '/images/storlyn/login/storlyn-logo.svg',
  novel: '/images/storlyn/login/storlyn-novel.svg',
  facebookIcon: '/images/storlyn/login/icon-facebook-logo.png',
  googleIcon: '/images/storlyn/login/icon-google-logo-storlyn.svg',
  appleIcon: '/images/storlyn/login/icon-apple-logo-storlyn.svg',
  emailIcon: '/images/storlyn/login/icon-email.png',
  emailCodeIcon: '/images/storlyn/login/icon-email-code.png',
} as const

export const loginConfig: LoginPageConfig = {
  theme,
  resources,
  texts: reactive(loginCommonConfig.texts),
}
